import React from 'react';
import * as _ from 'lodash';
import moment from 'moment';

import LocalStorageService from '../../services/utilities/LocalStorageService';

import {
  SPOT_STATUS, // スポット利用ステータス
  SPOT_TIMES, // スポット利用時間
  DISPLAY_FLAG,
  USER_ROLES, // 表示フラグ
} from '../../utilities/constants';
import { isPrimaryCompanyRoleId } from '../../utilities/roleUtility';
import { isTimeInsideLimit, formatHourMin } from '../../utilities/momentUtil';

import ReactDropDownCalender from '../ReactDropDownCalender';

import { FieldTreePartnerCompanyDropdown } from '../dropdowns/single/FieldTreePartnerCompanyDropdown';
import { FieldTreeJobDropdown } from '../dropdowns/single/FieldTreeJob';
import { FieldTreeUserDropdown } from '../dropdowns/single/FieldTreeUser';
import { FieldAItemDropdown } from '../dropdowns/single/FieldAItem';
import { FieldBItemDropdown } from '../dropdowns/single/FieldBItem';
import { FieldCItemDropdown } from '../dropdowns/single/FieldCItem';
import { FieldDItemDropdown } from '../dropdowns/single/FieldDItem';
import { FieldContractorUserDropdown } from '../dropdowns/single/FieldContractorUser';
import { MachineryTypeDropdown } from '../dropdowns/single/MachineryType';
import { MachineryDropdown } from '../dropdowns/single/Machinery';
import { MachineryUseLatestRegistrationDropdown } from '../dropdowns/single/MachineryUseLatestRegistration';
import { MachineryUseSpotHistoryDropdown } from '../dropdowns/single/MachineryUseSpotHistory';

import {
  FormList,
  FormListItem,
  FormElement,
  Validation,
} from '../CommonFormComponents';
import { ArrowDownIcon } from '../icons/ArrowDownIcon';
import SessionStorageService from '../../services/utilities/SessionStorageService';

/**
 * ゲート予定フォーム
 * @param roleId {int}
 * @param isEdit {bool} 編集・登録
 * @param isSpot {bool} スポット利用
 * @param isSpotToggle {bool} スポット業者切替フラグ
 * @param events {function} イベントハンドラ
 * @param errors {object}
 * @param workTime {object} 現場作業時間
 * @param viewOnlyFlag {int} 閲覧制限フラグ
 * @param values {object} フォーム入力値
 * @param itemNames
 * @param onVisibleDialog
 * @param pulldownName
 * @param options
 * @param loaded
 * @param {boolean} isLinkedIchiPlusMachineryUse
 */
export const MachineryUseForm = ({
  roleId,
  isEdit,
  isSpot,
  isSpotToggle,
  values,
  errors,
  workTime,
  viewOnlyFlag,
  events,
  itemNames,
  onVisibleDialog,
  pulldownName,
  options,
  loaded,
  isLinkedIchiPlusMachineryUse,
}) => {
  if (_.isEmpty(workTime)) {
    return false;
  }

  const workStartTime =
    workTime[SessionStorageService.getItem('work_hour_zone')].start;
  const workEndTime =
    workTime[SessionStorageService.getItem('work_hour_zone')].end;

  // 開始時間
  const startTime = () => {
    const start = moment(`${moment().format('YYYY/MM/DD')} ${workStartTime}`);
    const end = moment(`${moment().format('YYYY/MM/DD')} ${workEndTime}`);
    // 日またぎ
    if (end.isSameOrBefore(start)) {
      end.add(1, 'day');
    }

    let time = [];
    for (
      var target = start.clone();
      target.isBefore(end);
      target.add(15, 'minutes')
    ) {
      time.push(
        <option
          key={target.format('HH:mm:ss')}
          value={target.format('HH:mm:ss')}
          data-select={target.format('YYYY/MM/DD HH:mm:ss')}
        >
          {target.format('HH:mm')}
        </option>
      );
    }
    return time;
  };

  // 終了時間
  const endTime = () => {
    const start = moment(`${moment().format('YYYY/MM/DD')} ${workStartTime}`);
    const end = moment(`${moment().format('YYYY/MM/DD')} ${workEndTime}`);
    // 日またぎ
    if (end.isSameOrBefore(start)) {
      end.add(1, 'day');
    }
    start.add(15, 'minutes');

    let time = [];
    for (
      var target = start.clone();
      target.isSameOrBefore(end);
      target.add(15, 'minutes')
    ) {
      time.push(
        <option
          key={target.format('HH:mm:ss')}
          value={target.format('HH:mm:ss')}
          data-select={target.format('YYYY/MM/DD HH:mm:ss')}
        >
          {target.format('HH:mm')}
        </option>
      );
    }
    return time;
  };

  return (
    <div className='slide-view__body' style={{ height: 'calc(100vh - 120px)' }}>
      <div className='main__table set-width-dropdown'>
        <FormList isSpace={true}>
          {(Number(roleId) === USER_ROLES.partner.id ||
            Number(roleId) === USER_ROLES.foreman.id) &&
            !isEdit && (
              <FormListItem>
                <span
                  id='open-modal-confirm-copy'
                  className='btn-text form-list__copy-btn'
                  onClick={onVisibleDialog}
                >
                  前回登録した内容をコピー
                </span>
              </FormListItem>
            )}
          {isLinkedIchiPlusMachineryUse && (
            <FormListItem>「高車管理」から連携された機材予定です</FormListItem>
          )}
          {isEdit && (
            <FormListItem label='受付No'>
              <FormElement>
                <input
                  type='text'
                  disabled={viewOnlyFlag || isEdit}
                  value={values.today_receipt_no}
                />
              </FormElement>
            </FormListItem>
          )}
          <FormListItem label='期間' required={true}>
            {isEdit ? (
              <FormElement validate={errors.messages.use_date}>
                <div htmlFor='' className='input-date-range'>
                  {viewOnlyFlag || isLinkedIchiPlusMachineryUse ? (
                    <input
                      disabled
                      type='text'
                      className=' --col-xl-5 --col-lg-5 --col-md-10 --col-xs-10'
                      value={values.use_date}
                    />
                  ) : (
                    <ReactDropDownCalender
                      onChange={date => events.form.calender('use_date', date)}
                      value={values.use_date}
                    />
                  )}
                </div>
              </FormElement>
            ) : (
              <FormElement validate={errors.messages.use_date_start}>
                <div htmlFor='' className='input-date-range'>
                  <ReactDropDownCalender
                    name='use_date_start'
                    onChange={date =>
                      events.form.calender('use_date_start', date)
                    }
                    value={values.use_date_start}
                  />
                  <span className='input-date-range__bar--select'>〜</span>
                  <ReactDropDownCalender
                    name='use_date_end'
                    onChange={date =>
                      events.form.calender('use_date_end', date)
                    }
                    value={values.use_date_end}
                  />
                </div>
              </FormElement>
            )}
          </FormListItem>
          <SpotField
            isSpot={isSpot}
            values={values}
            events={events}
            errors={errors}
            viewOnlyFlag={viewOnlyFlag}
            isLinkedIchiPlusMachineryUse={isLinkedIchiPlusMachineryUse}
          />
          <CompanyField
            isSpot={isSpot}
            isSpotToggle={isSpotToggle}
            values={values}
            events={events}
            errors={errors}
            viewOnlyFlag={viewOnlyFlag}
            isLinkedIchiPlusMachineryUse={isLinkedIchiPlusMachineryUse}
            isEdit={isEdit}
            pulldownName={pulldownName}
          />
          <FormListItem label='機材種別' required={true}>
            <MachineryTypeDropdown
              value={values.machinery_type}
              error={errors.messages.machinery_type}
              readOnly={viewOnlyFlag || isLinkedIchiPlusMachineryUse}
              set={events.form.set}
              validate={events.form.validate}
              isFormListDefault={true}
            />
          </FormListItem>
          <FormListItem label='機材名' required={true}>
            <MachineryDropdown
              value={values.machinery_id}
              name={
                _.has(pulldownName, 'machinery_name')
                  ? pulldownName.machinery_name
                  : null
              }
              type={values.machinery_type}
              error={errors.messages.machinery_id}
              readOnly={viewOnlyFlag || isLinkedIchiPlusMachineryUse}
              set={events.form.machinery}
              validate={events.form.validate}
              isEdit={isEdit}
              defaultValue={values.machinery_id}
              defaultName={values.machinery_name}
              defaultType={values.machinery_type}
              isFormListDefault={true}
            />
          </FormListItem>
          <FormListItem label='性能・作業高さ'>
            <FormElement>
              <div>
                {values.spec_work_flat_height
                  ? values.spec_work_flat_height
                  : ''}
              </div>
            </FormElement>
          </FormListItem>
          <FormListItem label='性能・積載荷重'>
            <FormElement>
              <div>{values.spec_load ? values.spec_load : ''}</div>
            </FormElement>
          </FormListItem>
          <FormListItem label='管理会社'>
            <FormElement>
              <div>{values.company_name ? values.company_name : ''}</div>
            </FormElement>
          </FormListItem>
          <FormListItem label='時間' required={true}>
            <FormElement
              className={`form-list__element ${
                errors.messages.use_time || errors.messages.spot_time
                  ? 'form-list__element--error'
                  : ''
              }`}
            >
              <div htmlFor='' className='input-date-range'>
                <select
                  name='use_start_time'
                  disabled={viewOnlyFlag || isLinkedIchiPlusMachineryUse}
                  id='machinery-uses-use-start-time'
                  value={values.use_start_time}
                  onChange={e => events.form.setTime(e)}
                  onBlur={e => events.form.validate(e.target.name)}
                >
                  {!isTimeInsideLimit(
                    values.use_start_time,
                    workStartTime,
                    workEndTime
                  ) && (
                    <option disabled hidden value={values.use_start_time}>
                      {values.use_start_time.length > 0
                        ? formatHourMin(values.use_start_time)
                        : `---`}
                    </option>
                  )}
                  {startTime()}
                </select>
                <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
                <span className='input-date-range__bar'>〜</span>
                <select
                  name='use_end_time'
                  disabled={viewOnlyFlag || isLinkedIchiPlusMachineryUse}
                  id='machinery-uses-use-end-time'
                  value={values.use_end_time}
                  onChange={e => events.form.setTime(e)}
                  onBlur={e => events.form.validate(e.target.name)}
                >
                  {!isTimeInsideLimit(
                    values.use_end_time,
                    workStartTime,
                    workEndTime
                  ) && (
                    <option disabled hidden value={values.use_end_time}>
                      {values.use_end_time.length > 0
                        ? formatHourMin(values.use_end_time)
                        : `---`}
                    </option>
                  )}
                  {endTime()}
                </select>
                <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
              </div>
              <Validation validate={errors.messages.use_time} />

              {(!(viewOnlyFlag || isLinkedIchiPlusMachineryUse) ||
                values.spot_flag == SPOT_STATUS.spot.id) && (
                <div className='form-container__item'>
                  <label htmlFor='check' className='checkbox'>
                    <input
                      type='checkbox'
                      id='check'
                      name='spot_flag'
                      checked={values.spot_flag == SPOT_STATUS.spot.id}
                      disabled={viewOnlyFlag || isLinkedIchiPlusMachineryUse}
                      onChange={() =>
                        events.form.setSpotStatus(
                          values.spot_flag == SPOT_STATUS.spot.id
                        )
                      }
                    />
                    {!(viewOnlyFlag || isLinkedIchiPlusMachineryUse) && (
                      <i className='i-square i-3x' aria-hidden='true' />
                    )}
                    <span className={'form-list__item-text'}>スポット作業</span>
                  </label>
                </div>
              )}
              {values.spot_flag == SPOT_STATUS.spot.id && (
                <React.Fragment>
                  <div htmlFor='' className='input-date-range__radio show'>
                    <select
                      className='form-list__select--short'
                      name='spot_time'
                      value={values.spot_time}
                      disabled={viewOnlyFlag || isLinkedIchiPlusMachineryUse}
                      onChange={e =>
                        events.form.set(e.target.name, e.target.value)
                      }
                      onBlur={e => events.form.validate(e.target.name)}
                    >
                      {_.map(SPOT_TIMES, spotTime => {
                        return (
                          <option key={spotTime.id} value={spotTime.id}>
                            {spotTime.name}
                          </option>
                        );
                      })}
                    </select>
                    <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
                  </div>
                  {_.has(errors.messages, 'spot_time') && (
                    <Validation validate={errors.messages.spot_time} />
                  )}
                </React.Fragment>
              )}
            </FormElement>
          </FormListItem>

          <FormListItem label='運転者'>
            <MachineryUseLatestRegistrationDropdown
              value={values.driver_name}
              error={errors.messages.driver_name}
              fieldTreeId={values.field_tree_id}
              column='driver_name'
              readOnly={viewOnlyFlag}
              set={events.form.set}
              isFormListDefault={true}
              isOptional={true}
            />
          </FormListItem>
          <FormListItem label='作業指揮者'>
            <MachineryUseLatestRegistrationDropdown
              value={values.conductor_name}
              error={errors.messages.conductor_name}
              fieldTreeId={values.field_tree_id}
              column='conductor_name'
              readOnly={viewOnlyFlag}
              set={events.form.set}
              isFormListDefault={true}
              isOptional={true}
            />
          </FormListItem>
          <FormListItem label='誘導者'>
            <MachineryUseLatestRegistrationDropdown
              value={values.leading_worker_name}
              error={errors.messages.leading_worker_name}
              fieldTreeId={values.field_tree_id}
              column='leading_worker_name'
              readOnly={viewOnlyFlag}
              set={events.form.set}
              isFormListDefault={true}
              isOptional={true}
            />
          </FormListItem>
          <FormListItem label='安全指示事項'>
            <MachineryUseLatestRegistrationDropdown
              value={values.safety_instruction}
              error={errors.messages.safety_instruction}
              fieldTreeId={values.field_tree_id}
              column='safety_instruction'
              readOnly={viewOnlyFlag}
              set={events.form.set}
              isFormListDefault={true}
              isOptional={true}
            />
          </FormListItem>
          {/* 棟 */}
          {!_.isNil(values.displayFlg) &&
            values.displayFlg.field_item_list1_display_flag ===
              DISPLAY_FLAG.use.id && (
              <FormListItem label={itemNames.A}>
                <FieldAItemDropdown
                  title={itemNames.A}
                  value={values.a_item_id}
                  name={
                    _.has(pulldownName, 'a_item_name')
                      ? pulldownName.a_item_name
                      : null
                  }
                  error={errors.messages.a_item_id}
                  readOnly={viewOnlyFlag}
                  set={events.form.set}
                  options={options.field_item_a_lists || []}
                  loaded={loaded}
                  isFormListDefault={true}
                />
              </FormListItem>
            )}
          {/* 階 */}
          {!_.isNil(values.displayFlg) &&
            values.displayFlg.field_item_list2_display_flag ===
              DISPLAY_FLAG.use.id && (
              <FormListItem label={itemNames.B}>
                <FieldBItemDropdown
                  title={itemNames.B}
                  value={values.b_item_id}
                  name={
                    _.has(pulldownName, 'b_item_name')
                      ? pulldownName.b_item_name
                      : null
                  }
                  error={errors.messages.b_item_id}
                  readOnly={viewOnlyFlag}
                  set={events.form.set}
                  options={options.field_item_b_lists || []}
                  loaded={loaded}
                  isFormListDefault={true}
                />
              </FormListItem>
            )}
          {/* エリア */}
          {!_.isNil(values.displayFlg) &&
            values.displayFlg.field_item_list3_display_flag ===
              DISPLAY_FLAG.use.id && (
              <FormListItem label={itemNames.C}>
                <FieldCItemDropdown
                  title={itemNames.C}
                  value={values.c_item_id}
                  name={
                    _.has(pulldownName, 'c_item_name')
                      ? pulldownName.c_item_name
                      : null
                  }
                  error={errors.messages.c_item_id}
                  readOnly={viewOnlyFlag}
                  set={events.form.set}
                  options={options.field_item_c_lists || []}
                  loaded={loaded}
                  isFormListDefault={true}
                />
              </FormListItem>
            )}
          {/* 工区 */}
          {!_.isNil(values.displayFlg) &&
            values.displayFlg.field_item_list4_display_flag ===
              DISPLAY_FLAG.use.id && (
              <FormListItem label={itemNames.D}>
                <FieldDItemDropdown
                  title={itemNames.D}
                  value={values.d_item_id}
                  name={
                    _.has(pulldownName, 'd_item_name')
                      ? pulldownName.d_item_name
                      : null
                  }
                  error={errors.messages.d_item_id}
                  readOnly={viewOnlyFlag}
                  set={events.form.set}
                  options={options.field_item_d_lists || []}
                  loaded={loaded}
                  isFormListDefault={true}
                />
              </FormListItem>
            )}
          <FormListItem label='作業内容'>
            {viewOnlyFlag ? (
              <FormElement>
                <div className='form-list__textare--disable'>
                  {values.work_contents}
                </div>
              </FormElement>
            ) : (
              <MachineryUseLatestRegistrationDropdown
                value={values.work_contents}
                error={errors.messages.work_contents}
                fieldTreeId={values.field_tree_id}
                column='work_contents'
                readOnly={viewOnlyFlag}
                set={events.form.set}
                isTextArea={true}
                isOptional={true}
              />
            )}
          </FormListItem>
          <FormListItem label='元請担当者'>
            <FieldContractorUserDropdown
              value={values.manager_user_id}
              name={
                _.has(pulldownName, 'manager_user_name')
                  ? pulldownName.manager_user_name
                  : null
              }
              fieldTreeId={values.field_tree_id}
              jobId={values.job_id}
              readOnly={viewOnlyFlag}
              set={events.form.set}
              isFormListDefault={true}
              isOptional={true}
              dateToValue={isEdit ? values.use_date : values.use_date_end}
              isFilterByDateTo={true}
            />
          </FormListItem>
        </FormList>
      </div>
    </div>
  );
};

/**
 * 協力会社入力
 * @param isSpot {bool} スポット利用
 * @param values {object} 入力値
 * @param events {function}
 * @param errors {object} バリデーションメッセージ
 * @param viewOnlyFlag {int} 閲覧制限フラグ
 * @param isLinkedIchiPlusMachineryUse {boolean}
 */
const CompanyField = ({
  isSpot,
  isSpotToggle,
  values,
  events,
  errors,
  isEdit,
  viewOnlyFlag,
  pulldownName,
  isLinkedIchiPlusMachineryUse,
}) => {
  const roleId = LocalStorageService.getRoleId();

  if (isSpot == SPOT_STATUS.normal.id) {
    return (
      <React.Fragment>
        <FormListItem
          label='協力会社'
          required={true}
          className='form-list__item form-list__item-spot'
        >
          <FieldTreePartnerCompanyDropdown
            value={values.field_tree_id}
            name={
              _.has(pulldownName, 'company_name')
                ? pulldownName.company_name
                : null
            }
            error={errors.messages.field_tree_id}
            readOnly={viewOnlyFlag || isLinkedIchiPlusMachineryUse}
            isEdit={isEdit}
            isSpotToggle={isSpotToggle}
            set={events.form.set}
            validate={events.form.validate}
            otherComponnent={
              isPrimaryCompanyRoleId(roleId) && (
                <div className='form-list__element--btn'>
                  {!(viewOnlyFlag || isLinkedIchiPlusMachineryUse) && (
                    <div className='dropdown-multi-select__header'>
                      <button
                        className='btn-fixedsize--sub'
                        onClick={() => events.form.setSpot(SPOT_STATUS.spot.id)}
                      >
                        スポット業者
                      </button>
                    </div>
                  )}
                </div>
              )
            }
            dateTo={isEdit ? values.use_date : values.use_date_end}
            isFormListDefault={true}
          />
        </FormListItem>
        <FormListItem label='職種'>
          <FieldTreeJobDropdown
            value={values.job_id}
            name={
              _.has(pulldownName, 'job_name') ? pulldownName.job_name : null
            }
            error={errors.messages.job_id}
            fieldTreeId={values.field_tree_id}
            readOnly={viewOnlyFlag}
            isEdit={isEdit}
            set={events.form.set}
            userValueChangeFlag={values.userValueChangeFlag}
            dateTo={isEdit ? values.use_date : values.use_date_end}
            isFormListDefault={true}
            isOptional={true}
          />
        </FormListItem>
        <FormListItem label='職長'>
          <FieldTreeUserDropdown
            value={values.foreman_user_id}
            name={
              _.has(pulldownName, 'foreman_user_name')
                ? pulldownName.foreman_user_name
                : null
            }
            error={errors.messages.foreman_user_id}
            fieldTreeId={values.field_tree_id}
            jobId={values.job_id}
            readOnly={viewOnlyFlag}
            isEdit={isEdit}
            set={events.form.set}
            userValueChangeFlag={values.userValueChangeFlag}
            dateTo={isEdit ? values.use_date : values.use_date_end}
            isFormListDefault={true}
            isOptional={true}
          />
        </FormListItem>
      </React.Fragment>
    );
  } else {
    return null;
  }
};

/**
 * スポット業者入力
 * @param isSpot {bool} スポット利用
 * @param values {object} 入力値
 * @param events {function}
 * @param errors {object} バリデーションメッセージ
 * @param viewOnlyFlag {int} 閲覧制限フラグ
 * @param isLinkedIchiPlusMachineryUse {boolean}
 */
const SpotField = ({
  isSpot,
  values,
  events,
  errors,
  viewOnlyFlag,
  isLinkedIchiPlusMachineryUse,
}) => {
  if (isSpot == SPOT_STATUS.spot.id) {
    return (
      <React.Fragment>
        <FormListItem label='協力会社' required={true}>
          <MachineryUseSpotHistoryDropdown
            value={values.spot_company_name}
            error={errors.messages.spot_company_name}
            readOnly={viewOnlyFlag || isLinkedIchiPlusMachineryUse}
            events={events.form.setSpot}
            set={events.form.set}
            validate={events.form.validate}
          />
        </FormListItem>
        <FormListItem label='職種'>
          <FormElement>
            <input
              type='text'
              disabled={viewOnlyFlag}
              value={values.spot_foreman_user_job}
              maxLength={255}
              onChange={e =>
                events.form.set('spot_foreman_user_job', e.target.value)
              }
            />
          </FormElement>
        </FormListItem>
        <FormListItem label='職長'>
          <FormElement>
            <input
              type='text'
              disabled={viewOnlyFlag}
              value={values.spot_foreman_user_name}
              maxLength={255}
              onChange={e =>
                events.form.set('spot_foreman_user_name', e.target.value)
              }
            />
          </FormElement>
        </FormListItem>
      </React.Fragment>
    );
  } else {
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/components/forms/MachineryUses.jsx